((homepageTopCategoriesRedesign, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homeTopCategoriesCarouselRedesign = $('.js-home-top-categories--category-list-slider-redesign');
  };

  const bindUIActions = () => {
    $dom.homeTopCategoriesCarouselRedesign.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1.8,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            centerMode: false,
            centerPadding: '0px',
          },
        },
      ],
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepageTopCategoriesRedesign.init = init;
})((window.homepageTopCategoriesRedesign = window.homepageTopCategoriesRedesign || {}), jQuery);
